import {
  ChangeDetectionStrategy,
  Component,
  Input,
  OnInit,
  inject,
} from '@angular/core';
import { Utils } from '../../services/utilities';
import { CommonModule } from '@angular/common';
import { MomentPipe } from '../../pipes/moment.pipe';

@Component({
  selector: 'app-due-date-tag',
  templateUrl: './due-date-tag.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [CommonModule, MomentPipe],
})
export class DueDateTagComponent implements OnInit {
  readonly utilities = inject(Utils);
  @Input('due_date') due_date: string;
  color = 'initial';

  ngOnInit(): void {
    if (this.utilities.dateDiff(this.due_date, 'days') > 0) {
      this.color = 'red';
    } else if (this.utilities.dateDiff(this.due_date, 'days') == 0) {
      this.color = '#ef6c00';
    } else {
      this.color = 'initial';
    }
  }
}
